import React, { useEffect, useState } from "react";
import { FiClock, FiLogIn, FiLogOut } from "react-icons/fi";
import TileShell from "./TileShell";

const STATUS_TEXT = {
  IN: "Signed in",
  OUT: "Not signed in",
  IDLE: "Signed out for today",
};

const STATUS_PIP = {
  IN: "bg-green-500",
  OUT: "bg-amber-500",
  IDLE: "bg-gray-400",
};

const STATUS_CHIP = {
  IN: "bg-green-50 text-green-700",
  OUT: "bg-amber-50 text-amber-700",
  IDLE: "bg-gray-100 text-gray-600",
};

const AttendanceTile = ({
  status = "OUT",
  location,
  lastInLabel,
  onAction,
  className = "",
}) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timer;
    const schedule = () => {
      timer = setTimeout(() => {
        setNow(new Date());
        schedule();
      }, 60000 - (Date.now() % 60000));
    };
    schedule();
    return () => clearTimeout(timer);
  }, []);

  const signedIn = status === "IN";
  const idle = status === "IDLE";

  return (
    <TileShell
      icon={FiClock}
      title="Attendance"
      className={className}
      bodyClassName="flex flex-col"
    >
      <span
        className={`inline-flex w-fit items-center gap-2 rounded-full px-2.5 py-1 text-xs font-semibold ${
          STATUS_CHIP[status] || STATUS_CHIP.OUT
        }`}
      >
        <span
          className={`h-2 w-2 rounded-full ${
            STATUS_PIP[status] || STATUS_PIP.OUT
          }`}
        />
        {STATUS_TEXT[status] || STATUS_TEXT.OUT}
      </span>

      <p className="mt-5 text-4xl font-extrabold tracking-tight text-gray-900">
        {now.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })}
      </p>

      <p className="mt-1 text-xs text-gray-500">
        {signedIn
          ? `Last in${location ? ` · ${location}` : ""}${
              lastInLabel ? ` · ${lastInLabel}` : ""
            }`
          : idle
          ? "Your attendance for today is recorded."
          : "Sign in to record your attendance."}
      </p>

      {!idle && (
        <button
          type="button"
          onClick={onAction}
          className={`mt-auto inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white transition ${
            signedIn
              ? "bg-rose-500 hover:bg-rose-600"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {signedIn ? <FiLogOut size={15} /> : <FiLogIn size={15} />}
          {signedIn ? "Sign Out" : "Sign In"}
        </button>
      )}
    </TileShell>
  );
};

export default AttendanceTile;
